module.exports = __webpack_public_path__ + "static/media/Privacy Policy-05_26_2020-8.5453b07f.png";